import React, { useState, useEffect } from "react";
import {
  AppContext,
  defaultAppContextData,
} from "../../../../services/appData";
import { useAuthService, useContextService } from "../../../../services";
import { IFileProcessModel } from "../../../../typings/models/FileProcessModel";
import { getFileProcessRecords } from "../../../../api/apimethods";
import FileProcessGrid from "./FileProcessGrid";

interface DashboardProps {
  data: any;
}

const FileProcessDashboard: React.FC<DashboardProps> = ({ data }) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  //   const [data, setData] = useState<IFileProcessModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch data from API on component mount
  //   useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         const response = await getFileProcessRecords("Pets");
  //         setData(response.data);
  //         setIsLoading(false);
  //       } catch (error) {
  //         setIsLoading(false);
  //         console.error("Error fetching data:", error);
  //       }
  //     };

  //     fetchData();
  //   }, []);

  return (
    <>
      <div>
        <h1>t</h1>
        <FileProcessGrid data={data} isLoading={isLoading} />
      </div>
    </>
  );
};

export default FileProcessDashboard;
